<template>
  <Modal v-if="showModal" :title="promo.modalTitle" :strapi-image-object="promo.media" @close="close">
    <div :class="{ 'md:mx-auto md:w-[calc(100%*5/7)]': !showLabels }">
      <div class="flex flex-col gap-y-10 mb-10">
        <MoleculeModalRowButton v-if="showLabels" :item="{ title: 'Акция в клубе', controls: promoTags }" />
        <MoleculeModalRowText v-if="showLabels" class="!mb-0" :item="{ title: 'Об акции', text: promo.description }" />
        <AtomText v-else :content="promo.description" class-name="whitespace-pre-wrap" />
      </div>
      <div :class="showLabels ? 'flex flex-col md:grid grid-cols-7 md:gap-x-4' : ''">
        <div v-if="showLabels" class="col-span-2 md:pt-1 -md:text-sm mb-1" />
        <div class="flex flex-wrap gap-[6px]" :class="{ 'col-span-4': showLabels }">
          <AtomButton
            v-if="yclientsUrl"
            class="md:self-baseline w-full"
            tag="button"
            type="button"
            :data-yclients-url="yclientsUrl"
          >
            ЗАПИСАТЬСЯ
          </AtomButton>
          <template v-else>
            <div v-if="successShow">В&nbsp;ближайшее время наш менеджер свяжется с&nbsp;вами.</div>
            <form v-else class="flex flex-col gap-y-8 md:gap-y-10" @submit.prevent="send">
              <div>
                <MoleculeInputText
                  v-model="payload.first_name"
                  :error="submitted && error.first_name"
                  label="Имя*"
                  class="item-input mb-2"
                  type="text"
                  @blur="validate('first_name')"
                  @input="validate('first_name')"
                />
                <MoleculeInputText v-model="payload.email" label="Email" type="email" class="item-input mb-2" />
                <MoleculeInputPhone
                  :error="submitted && error.phone"
                  :value="payload.phone"
                  label="Телефон*"
                  type="tel"
                  theme="white"
                  @onInput="onInputPhone"
                  @blur="onInputPhone"
                />
                <MoleculeTextarea
                  v-model="payload.message"
                  :error="submitted && error.message"
                  label="Сообщение"
                  class="item-input mb-2"
                  @blur="validate('message')"
                  @input="validate('message')"
                />
              </div>
              <MoleculeRadio
                v-model="radio"
                :error="submitted && error.radio"
                type="radio"
                :checked="radio"
                label="С&nbsp;<a class='underline-offset-2 underline' href='https://www.encorefitness.ru/privacy-policy' target='_blank'>политикой обработки персональных данных</a> ознакомлен. Согласен на&nbsp;<a class='underline-offset-2 underline' href='https://www.encorefitness.ru/uploads/Согласие_на_обработку_ПД_2025.pdf' target='_blank'>обработку моих персональных данных</a>."
                @input="error.radio = !radio"
              />
              <MoleculeRadio
                v-model="receiving_advertising"
                class="-mt-4"
                type="radio"
                :checked="receiving_advertising"
                label="Согласен на&nbsp;<a class='underline-offset-2 underline' href='https://www.encorefitness.ru/uploads/Согласие_на_рекламу.pdf' target='_blank'> получение рекламных и/или информационных сообщений</a>."
              />
              <AtomButton :disabled="submitting" class="md:self-baseline w-full" tag="button" type="submit"
                >ОТПРАВИТЬ</AtomButton
              >
              <div v-if="errorShow" class="text-red text-center text-sm mt-5">Произошла ошибка. Попробуйте позже</div>
            </form>
          </template>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import AtomButton from '@/components/atoms/AtomButton'
import AtomText from '@/components/atoms/AtomText'
import MoleculeInputText from '@/components/molecules/forms/MoleculeInputText'
import MoleculeInputPhone from '@/components/molecules/forms/MoleculeInputPhone'
import MoleculeRadio from '@/components/molecules/forms/MoleculeRadio'
import MoleculeTextarea from '@/components/molecules/forms/MoleculeTextarea'
import MoleculeModalRowButton from '@/components/molecules/modals/MoleculeModalRowButton'
import Modal from '@/components/templates/layouts/Modal'
import MoleculeModalRowText from '@/components/molecules/modals/MoleculeModalRowText'
import { getUtmList } from '@/utils/cookies'
import { getClubGoalName } from '@/utils/getClubAsYMGoalName'

export default {
  components: {
    MoleculeModalRowText,
    Modal,
    AtomButton,
    AtomText,
    MoleculeInputText,
    MoleculeInputPhone,
    MoleculeTextarea,
    MoleculeRadio,
    MoleculeModalRowButton,
  },
  data: () => {
    return {
      payload: {
        first_name: '',
        email: '',
        phone: '',
        message: '',
      },
      error: {
        first_name: null,
        phone: null,
        message: null,
        radio: null,
      },
      submitted: false,
      submitting: false,
      successShow: false,
      errorShow: false,
      radio: false,
      receiving_advertising: false,
      modal: null,
    }
  },
  computed: {
    showModal() {
      return !this.$store.getters['entryLoaderScreen/hasPreloadScreen']
    },
    club() {
      return this.$store.getters['modules/content/clubs'].find(c => c.slug === this.$route.params.id) || { title: '' }
    },
    promo() {
      return this.club.actions.find(c => c.slug === this.$route.params.slug) || {}
    },
    promoTags() {
      return (this.promo.clubs || []).map(({ title }) => ({ title }))
    },
    showLabels() {
      return this.promo.showLabels !== false
    },
    yclientsUrl() {
      const link = (this.promo.yclients || '').replace(/\/$/, '')
      if (!link) return ''
      return /\/widgetJS$/i.test(link) ? link : `${link}/widgetJS`
    },
  },
  mounted() {
    const {
      params: { slug },
    } = this.$route

    if (slug && slug !== this.promo.slug) {
      return this.$nuxt.error({ statusCode: 404, message: 'Страница не найдена' })
    }
  },
  destroyed() {
    const isToParentRoute = this.$route.path.startsWith('/team')
    if (isToParentRoute) {
      this.$store.dispatch('pageTransition/toDefault')
    }
  },
  methods: {
    send() {
      this.submitted = true
      if (!this.submitting && this.validateForm()) {
        this.submitting = true

        const phone = `+${this.payload.phone.replace(/[^0-9]/g, '')}`
        let visitorUid = 'unknown'
        try {
          visitorUid = window.AMOPIXEL.getVisitorUid()
        } catch (e) {}

        const utmList = getUtmList(this.$cookies)

        const payload = {
          ...this.payload,
          phone,
          action: this.promo.modalTitle,
          club: this.club.slug,
          visitor_uid: visitorUid,
          receiving_advertising: this.receiving_advertising,
          ...utmList,
        }

        let clientId = 0
        try {
          clientId = window?.yaCounter37069155?.getClientID?.() ?? this.$cookies?.get('_ym_uid') ?? 0
        } catch (error) {
          this.$sentry.captureException(error)
        }

        if (clientId) {
          payload.clientId = String(clientId)
        }

        let roistatVisit = 'nocookie'
        try {
          roistatVisit = this.$cookies?.get('roistat_visit') || 'nocookie'
        } catch (error) {
          this.$sentry.captureException(error)
        }

        payload.roistat_visit = String(roistatVisit)

        let actionName = 'success-form-action'
        if (!this.promo.showLink) {
          payload.type = 'promo'
          actionName = 'success-form-promo'
        }

        this.$axios
          .post(
            '/api/forms/action',
            {
              data: payload,
            },
            { __component: `pages/clubs/promo/${this?.club?.slug ?? '_slug'}` },
          )
          .then(() => {
            this.successShow = true
            this.sendReachGoal(getClubGoalName(payload.club))
            this.sendReachGoal(actionName, { api: 'forms/action', action: this.promo.modalTitle, club: payload.club })
          })
          .catch(e => {
            this.errorShow = true
          })
          .finally(() => {
            this.submitting = false
          })
      }
    },
    validateForm() {
      Object.keys(this.payload).forEach(key => {
        this.validate(key)
      })

      this.error.radio = !this.radio

      return !Object.values(this.error).some(Boolean)
    },
    validate(key) {
      const textIsInvalid = v => !(v || '').trim()
      const schema = {
        first_name: textIsInvalid,
        phone: v => !v || v.length !== 16,
      }
      if (key in this.error && schema[key]) {
        const value = this.payload[key]
        this.error[key] = schema[key](value)
      }
    },
    onInputPhone(value, objValidPhone) {
      this.payload.phone = value

      if (!this.payload.phone || !objValidPhone.isValid) this.error.phone = !objValidPhone.isValid
      else this.error.phone = false
    },
    close() {
      const canBack = history.length > 2
      if (canBack) {
        this.$router.back()
      } else {
        this.$router.push(`/clubs/${this.$route.params.id}`)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
